/* eslint-disable max-lines -- Can't be fixed in a timely manner */
import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';
import { storageKeys, userKeys } from 'settings';
import { APIHandler, DataHandler, Email, Register, StorageHandler } from 'C4';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const checkInputValidity = () =>
  Array.from(document.getElementsByTagName('input')).every((val) => val.checkValidity() === true);

  const checkInputValidityFields = () => {
    const inputs = document.getElementsByTagName('input');
    const inputArray = [];

    Array.from(inputs).forEach((input) => {
      inputArray.push(input);
    });
    
    const emptyFields = [];
    inputs.forEach(function(input) {
      if (input.checkValidity() === false) {
        const name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
        emptyFields.push(name);
      }
    });
  
    return emptyFields;
  };

  const Zoom = cssTransition({
    enter: 'zoomIn',
    exit: 'zoomOut',
    duration: [500, 800],
  });

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: {
        email: '',
        first_name: '',
        last_name: '',
        agency_name: '',
        state: '',
        country: 'US',
        marketing_opt_in: false,
      },
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      redirect: '',
      appId: 0,
    };

    document.body.classList.add('no-scroll');

    const { path } = this.props;
    StorageHandler.exists(storageKeys.user).then((res) => {
      if (path !== '/logout' && res) {
        console.log(res);
        console.log('ffff uqla')
        if (res.response.sales_companion_registered !== null) {
          this.setState({ redirect: '/main' });
        } 
      } else if (path === '/logout') {
        sessionStorage.clear();
        StorageHandler.removeKeys(userKeys);
        window.location.href = `https://auth.quarkexpeditions.com/logout?returnTo=${encodeURIComponent('https://quarkexpeditionspolarpro.com/')}&client_id=Fh8fwP677M0AiKSf7ZYBgNglYVKXONbV`;
      } else if (path === '/register') {
      } else {
        StorageHandler.removeKeys(userKeys);
      }
    });

    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
  }

  async componentDidMount() {
    const { path } = this.props;
    this.setAppId();

    if (path !== '/register') {
      await this.checkRedirect();
      if (path === '/logout') {
        const openId = Object.keys(sessionStorage);
        for (let i = 0; i < openId.length; i++) {
          const key = openId[i];
          if (key.startsWith('oidc.user:')) {
            sessionStorage.removeItem(openId[key]);
          }
        }

        StorageHandler.remove(storageKeys.lang);
      }
    }

  }

  async setAppId() {
    const { path } = this.props;
    this.setState({ appId: await DataHandler.matchAppId() });
    if (path === '/register') {
      this.setState({ display: 'register' });

      const openId = Object.keys(sessionStorage);
      let userQuark;    
      let userEmail;
      for (let i = 0; i < openId.length; i++) {
        const key = openId[i];
        if (key.startsWith('oidc.user:')) {
          const sessionData = JSON.parse(sessionStorage.getItem(key));
          userQuark = sessionData.profile;
          userEmail = sessionData.email;
          break;
        }
      }
      console.log(userQuark);
      console.log(userEmail);
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          this.setState({
            userInput: {
              ...this.state.userInput,
              email: userEmail ? userEmail : userQuark.name,
              first_name: res.response.first_name ? res.response.first_name : '',
              last_name: res.response.last_name ? res.response.last_name : '',
              agency_name: res.response.agency_name ? res.response.agency_name : '',
              state: res.response.state ? res.response.state : '',
              country: res.response.country ? res.response.country : '',
            },
          });
        } else {
          this.setState({
            userInput: {
              ...this.state.userInput,
              email: userEmail ? userEmail : userQuark.name,
              first_name: '',
              last_name: '',
              agency_name: '',
              state: '',
              country: '',
            },
          });
        }
      });
    }
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    const el = document.querySelector('.form__message');
    el.style.opacity = 1;
    el.style.color = 'black';
  }

  async checkRedirect() { 
    const { path } = this.props;
    const userExists = await StorageHandler.exists(storageKeys.user);
    if (path !== '/logout' && userExists) {
      this.setState({ redirect: '/main' }); 
    } else {
      StorageHandler.removeKeys(userKeys);
      if (path !== '/login') {
        this.setState({ redirect: '/login' });
      }
    }
  }

  backHandler() {
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
    this.setState({ display: 'login', message: '' });
  }

  login(userInfo, saveInfo, customRedir) {
    const { year } = StorageHandler.expire;
    if (saveInfo) StorageHandler.save(storageKeys.user, userInfo, year);
    document.body.classList.remove('no-scroll');
    this.setState({ redirect: customRedir || '/main' });
  }

  async loginHandler(event) {
    const submit = event.target;
    submit.disabled = true;

    if (checkInputValidity()) {
      event.preventDefault();
      const {
        userInput: { email },
      } = this.state;

      const userExists = await StorageHandler.exists(storageKeys.user);
      if (!userExists) {
        this.setAnim('loadingAnim', true);
        const appId = await DataHandler.matchAppId();
        const userInfo = await APIHandler.getUser(appId, email);
        if (APIHandler.ok(userInfo.response)) {
          this.login(userInfo, true);
        } else {
          const newInput = this.state.userInput;
          newInput.email = email;
          this.setState({ display: 'register', userInput: newInput });
        }
        if (submit) submit.disabled = false;
      } else {
        const userInfo = await StorageHandler.load(storageKeys.user);
        this.login(userInfo, false);
      }
    } else submit.disabled = false;
  }

  changeHandler({ target }) {
    const { checked, name, type, value } = target;
    const input = this.state.userInput;
    input[name] = type === 'checkbox' ? checked : value;
    this.setState({ userInput: input });
  }

  async registerHandler(event) {
    const submit = event.target;
    const { userInput, appId } = this.state;

    submit.disabled = true;
    event.preventDefault();

    if (checkInputValidity()) {
      this.setAnim('loadingAnimRegister', true);
      const registerObject = userInput;

      await APIHandler.setUser(userInput.email, appId, registerObject);
      const user = await APIHandler.getUser(appId, userInput.email);
      this.login(user, true);
    } else {
      const invalidFields =
      'Please fill in all the required fields: ' + checkInputValidityFields().join(', ');
    toast.error(invalidFields, {
      position: 'bottom-center',
      transition: Zoom,
      autoClose: 10000,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: true,
    });

      submit.disabled = false;
    }
  }

  render() {
    const { path } = this.props;
    const { animation, display, message, redirect, userInput } = this.state;

    const { email, first_name, last_name, agency_name, state, country } = userInput;
    const { loadingAnim, loadingAnimRegister } = animation;
    const span = { role: 'button', 'data-type': 'iframe' };

    return (
      <form className="login__form">
        <ToastContainer />
        {display === 'login' && (
          <Email change={this.changeHandler} defaultVal={email} loadingAnim={loadingAnim} submit={this.loginHandler} />
        )}

        {path === '/register' && (
          <Register
            back={this.backHandler}
            change={this.changeHandler}
            defaultVal={email}
            firstName={first_name}
            lastName={last_name}
            agencyName={agency_name}
            userState={state}
            country={country}
            loadingAnimRegister={loadingAnimRegister}
            submit={this.registerHandler}
          />
        )}

        <h3 className="form__message">{message}</h3>
        {redirect.length > 0 && redirect !== path && <Redirect push to={redirect} />}

        <p className="legal">
          {i18n.translate('loginScreen.tAndC.agree')}
          <span data-fancybox="privacy" href="https://travpromobile.com/privacy_policy.html" {...span}>
            {i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>

          {i18n.translate('loginScreen.tAndC.and')}

          <span data-fancybox="terms" href="https://travpromobile.com/terms_of_use.html" {...span}>
            {i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>
        </p>
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
